<div class="readonlytbox milestone-panel">
  @if (loading) {
    <div class="loading-indicator">
      <p-progressSpinner></p-progressSpinner>
    </div>
  }

  @if (hasMilestoneData) {
    <div class="ui-g pl-2 pr-4 div-month-selection pb-2">
      <div class="ui-g-12 ui-md-4 ui-lg-4">Month</div>
      <div class="ui-g-12 ui-md-4 ui-lg-4 dropdown">
        <p-select
          [options]="monthList"
          [(ngModel)]="selectedMonth"
          (onChange)="onMonthChange(selectedMonth)"
          placeholder="--SELECT--"
          optionLabel="label"></p-select>
      </div>
      <div class="ui-g-12 ui-md-4 ui-lg-4"></div>
    </div>
  }

  @if (hasMilestoneData) {
    <div class="milestone2-tabs">
      @if (programTypeId === ProgramType.MSSP) {
        <p-tabs scrollable [(value)]="selectedTab">
          <p-tablist>
            @if (showSecurityACR) {
              <p-tab [value]="0">Security ACR</p-tab>
            }
            @if (showBilledRevenue) {
              <p-tab [value]="1">M365 Security Sales</p-tab>
            }
          </p-tablist>
          <p-tabpanels>
            <p-tabpanel [value]="0">
              <form class="form-acr" [formGroup]="formSecurityACR">
                <div class="rtnav ui-g">
                  <div class="ui-g-6 msgbox-6">
                    @for (
                      message of msgsACRMilestone2InvoiceDetails;
                      track message
                    ) {
                      <p-message
                        [life]="3000"
                        [text]="message.detail"></p-message>
                    }
                  </div>
                  @if (!btnNavACRM2Payment) {
                    <div class="ui-g-5"></div>
                  }
                  @if (btnNavACRM2Payment) {
                    <div class="ui-g-5">
                      <button
                        type="button"
                        pButton
                        (click)="editACRM2PaymentCancel()"
                        class="ui-button-secondary flat fl-rt">
                        Cancel
                      </button>
                      <button
                        type="submit"
                        pButton
                        (click)="onSubmitACRM2PaymentDetails(formSecurityACR)"
                        class="flat btnmr fl-rt">
                        Save
                      </button>
                    </div>
                  }
                  <div class="ui-g-1 edit-history-icon">
                    <span
                      class="fa fa-pencil ico cpointer fl-rt"
                      pTooltip="Edit"
                      (click)="editACRM2PaymentDetails()"
                      (keydown.enter)="editACRM2PaymentDetails()"
                      tabindex="0"
                      tooltipPosition="bottom"></span>
                  </div>
                </div>
                <div class="ui-g">
                  <div class="ui-g-12 ui-md-4 ui-lg-4">
                    Milestone 2 Engagement Type
                  </div>
                  <div class="ui-g-12 ui-md-4 ui-lg-4">
                    <input
                      type="text"
                      pInputText
                      readonly
                      formControlName="payoutMetric" />
                  </div>
                  <div class="ui-g-12 ui-md-4 ui-lg-4"></div>
                </div>
                <div class="ui-g">
                  <div class="ui-g-12 ui-md-4 ui-lg-4">
                    Milestone 2 Payment Amount
                  </div>
                  <div class="ui-g-12 ui-md-4 ui-lg-4">
                    <input
                      type="text"
                      pInputText
                      readonly
                      formControlName="paymentAmount" />
                  </div>
                  <div class="ui-g-12 ui-md-4 ui-lg-4"></div>
                </div>
                <div class="ui-g">
                  <div class="ui-g-12 ui-md-4 ui-lg-4">
                    Milestone 2 Paid Date
                  </div>
                  <div class="ui-g-12 ui-md-4 ui-lg-4">
                    <p-datepicker
                      appendTo="body"
                      formControlName="paidDate"
                      placeholder="mm/dd/yy"
                      dateFormat="mm/dd/yy"
                      [readonlyInput]="true"
                      [showOnFocus]="false"
                      [showIcon]="isReadonlyACRMilestone2Payment === false"
                      [iconDisplay]="'input'"
                      [class.readonlycaltb]="true"
                      [defaultDate]="maxYearDate">
                    </p-datepicker>
                  </div>
                </div>
                <div class="ui-g">
                  <div class="ui-g-12 ui-md-4 ui-lg-4">
                    Payment Document Number
                  </div>
                  <div class="ui-g-12 ui-md-4 ui-lg-4">
                    <input
                      type="text"
                      pInputText
                      [readonly]="isReadonlyACRMilestone2Payment"
                      formControlName="paymentDocumentNumber" />
                  </div>
                  <div class="ui-g-12 ui-md-4 ui-lg-4"></div>
                </div>
                <div class="ui-g">
                  <div class="ui-g-12 ui-md-4 ui-lg-4">Invoice</div>
                  <div class="ui-g-12 ui-md-4 ui-lg-4">
                    <input
                      type="text"
                      pInputText
                      [readonly]="isReadonlyACRMilestone2Payment"
                      formControlName="invoiceNumber" />
                  </div>
                  <div class="ui-g-12 ui-md-4 ui-lg-4"></div>
                </div>
                <div class="ui-g">
                  <div class="ui-g-12 ui-md-4 ui-lg-4">
                    Payment Central Transaction ID
                  </div>
                  <div class="ui-g-12 ui-md-4 ui-lg-4">
                    <input
                      type="text"
                      pInputText
                      [readonly]="isReadonlyACRMilestone2Payment"
                      formControlName="paymentCentralTransactionId" />
                  </div>
                  <div class="ui-g-12 ui-md-4 ui-lg-4"></div>
                </div>
                <div class="ui-g">
                  <div class="ui-g-12 ui-md-4 ui-lg-4">Payment Status</div>
                  <div class="ui-g-12 ui-md-4 ui-lg-4">
                    <p-select
                      appendTo="body"
                      [options]="paymentStatuses"
                      [readonly]="isReadonlyACRMilestone2Payment"
                      [class.readonlydd]="false"
                      formControlName="paymentStatus"
                      placeholder="--SELECT--"
                      optionLabel="paymentStatusName"></p-select>
                  </div>
                </div>
              </form>
            </p-tabpanel>
            <p-tabpanel [value]="1">
              <form [formGroup]="formBilledRevenue">
                <div class="rtnav ui-g">
                  <div class="ui-g-6 msgbox-6">
                    @for (message of msgsM365Milestone2Details; track message) {
                      <p-message
                        [life]="3000"
                        [text]="message.detail"></p-message>
                    }
                  </div>
                  @if (!btnNavM365M2Payment) {
                    <div class="ui-g-5"></div>
                  }
                  @if (btnNavM365M2Payment) {
                    <div class="ui-g-5">
                      <button
                        type="button"
                        pButton
                        (click)="editM365M2PaymentCancel()"
                        class="ui-button-secondary flat fl-rt">
                        Cancel
                      </button>
                      <button
                        type="submit"
                        pButton
                        (click)="
                          onSubmitM365M2PaymentDetails(formBilledRevenue)
                        "
                        class="flat btnmr fl-rt">
                        Save
                      </button>
                    </div>
                  }
                  <div class="ui-g-1 edit-history-icon">
                    <span
                      class="fa fa-pencil ico cpointer fl-rt"
                      pTooltip="Edit"
                      (click)="editM365M2PaymentDetails()"
                      (keydown.enter)="editM365M2PaymentDetails()"
                      tabindex="0"
                      tooltipPosition="bottom"></span>
                  </div>
                </div>

                <div class="ui-g">
                  <div class="ui-g-12 ui-md-4 ui-lg-4">
                    Milestone 2 Engagement Type
                  </div>
                  <div class="ui-g-12 ui-md-4 ui-lg-4">
                    <input
                      type="text"
                      pInputText
                      readonly
                      formControlName="payoutMetric" />
                  </div>
                  <div class="ui-g-12 ui-md-4 ui-lg-4"></div>
                </div>
                <div class="ui-g">
                  <div class="ui-g-12 ui-md-4 ui-lg-4">
                    Milestone 2 Payment Amount
                  </div>
                  <div class="ui-g-12 ui-md-4 ui-lg-4">
                    <input
                      type="text"
                      pInputText
                      readonly
                      formControlName="paymentAmount" />
                  </div>
                  <div class="ui-g-12 ui-md-4 ui-lg-4"></div>
                </div>

                <div class="ui-g">
                  <div class="ui-g-12 ui-md-4 ui-lg-4">
                    Milestone 2 Paid Date
                  </div>
                  <div class="ui-g-12 ui-md-4 ui-lg-4">
                    <p-datepicker
                      appendTo="body"
                      formControlName="paidDate"
                      placeholder="mm/dd/yy"
                      dateFormat="mm/dd/yy"
                      [readonlyInput]="true"
                      [showOnFocus]="false"
                      [showIcon]="isReadonlyM65Milestone2Payment === false"
                      [iconDisplay]="'input'"
                      [class.readonlycaltb]="true"
                      [defaultDate]="maxYearDate">
                    </p-datepicker>
                  </div>
                </div>
                <div class="ui-g">
                  <div class="ui-g-12 ui-md-4 ui-lg-4">
                    Payment Document Number
                  </div>
                  <div class="ui-g-12 ui-md-4 ui-lg-4">
                    <input
                      type="text"
                      pInputText
                      [readonly]="isReadonlyM65Milestone2Payment"
                      formControlName="paymentDocumentNumber" />
                  </div>
                  <div class="ui-g-12 ui-md-4 ui-lg-4"></div>
                </div>
                <div class="ui-g">
                  <div class="ui-g-12 ui-md-4 ui-lg-4">Invoice</div>
                  <div class="ui-g-12 ui-md-4 ui-lg-4">
                    <input
                      type="text"
                      pInputText
                      [readonly]="isReadonlyM65Milestone2Payment"
                      formControlName="invoiceNumber" />
                  </div>
                  <div class="ui-g-12 ui-md-4 ui-lg-4"></div>
                </div>
                <div class="ui-g">
                  <div class="ui-g-12 ui-md-4 ui-lg-4">
                    Payment Central Transaction ID
                  </div>
                  <div class="ui-g-12 ui-md-4 ui-lg-4">
                    <input
                      type="text"
                      pInputText
                      [readonly]="isReadonlyM65Milestone2Payment"
                      formControlName="paymentCentralTransactionId" />
                  </div>
                  <div class="ui-g-12 ui-md-4 ui-lg-4"></div>
                </div>
                <div class="ui-g">
                  <div class="ui-g-12 ui-md-4 ui-lg-4">Payment Status</div>
                  <div class="ui-g-12 ui-md-4 ui-lg-4">
                    <p-select
                      appendTo="body"
                      [options]="paymentStatuses"
                      [readonly]="isReadonlyM65Milestone2Payment"
                      [class.readonlydd]="false"
                      formControlName="paymentStatus"
                      placeholder="--SELECT--"
                      optionLabel="paymentStatusName"></p-select>
                  </div>
                </div>
              </form>
            </p-tabpanel>
          </p-tabpanels>
        </p-tabs>
      }
    </div>
  }

  @if (!hasMilestoneData) {
    <div>
      <h3>
        Payment Milestone 2 data (Payout Metric) not yet available for the
        activity
      </h3>
    </div>
  }
</div>
